export default {
  title_one: 'Supprimer {{count}} modificateurs ?',
  title_other: 'Supprimer {{count}} modificateurs ?',
  description: '<strong>{{items}}</strong> sera retiré du menu',
  buttons: {
    yes: 'Oui',
    no: 'Non',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Échec de la suppression du modificateur',
    failed_to_delete_modifier_other: 'Échec de la suppression des modificateurs',
    modifiers_got_deleted_one: 'Modificateur supprimé',
    modifiers_got_deleted_other: 'Modificateurs supprimés',
  },
};
